import api from "../../../axios";

export const getToken = async (iTokenId) => {
  const aResponse = await api.get(`/users/password/tokens/${iTokenId}`);
  return aResponse.data;
};
